import { Dialog } from "@headlessui/react";
import { NXRightArrow, NXLeftArrow, NXCross } from "../icons";
import { InputField } from "./common";

interface NxtbnDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: any;
  closeDirection?: 'left' | 'right' | 'none'; // Optional prop for closeDirection
  onCloseDirectionClick?: () => void;
  size?: 'sm' | 'md' | 'lg'; // New optional prop for size
}

function NxtbnDrawer({
  isOpen,
  onClose,
  title,
  children,
  closeDirection = 'right',
  onCloseDirectionClick,
  size = 'md' // Default value for size
}: NxtbnDrawerProps) {
  // Determine the drawer width based on size prop
  const sizeClasses = {
    sm: 'w-full md:w-1/3 lg:w-1/3', // One-third on medium/large, full width on small
    md: 'w-full md:w-2/3 lg:w-1/2',  // Two-thirds on medium, half on large, full width on small
    lg: 'w-full md:w-full lg:w-3/4'   // Full width on medium and small, three-fourths on large
  };

  return (
    <Dialog className="relative z-[110]" open={isOpen} onClose={onClose}>
      {/* Backdrop large scren */}
      <div
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
        onClick={onClose}
      ></div>
      
      {/* Drawer Container */}
      <div
        className={`fixed inset-y-0 right-0 z-20 flex transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        } ${sizeClasses[size] || sizeClasses.md}`} // Apply size classes
      >


        {/* Left Padding Area to Act as Backdrop (mobile) */}
    <div
      className="md:block sm:block w-10 h-full bg-transparent cursor-pointer"
      onClick={onClose}
    ></div>


        <div className="relative flex w-full flex-col bg-white shadow-xl overflow-hidden">
          
          {/* Close Button and Title */}
          <div className="flex justify-between items-center p-4 border-b">
            {closeDirection !== 'none' && (
              <button
                onClick={onCloseDirectionClick ? onCloseDirectionClick : onClose}
                className="text-gray-400 hover:text-gray-600 focus:outline-none"
              >
                <span className="sr-only">Close panel</span>
                {closeDirection === 'right' && <NXRightArrow aria-hidden="true" className="h-5 w-5" />}
                {closeDirection === 'left' && <NXLeftArrow aria-hidden="true" className="h-5 w-5" />}
              </button>
            )}
            <h2 className="text-lg font-medium text-right">{title}</h2> {/* Title aligned to the right */}
            
            {/* Close button if there is no direction */}
            {closeDirection === 'none' && ( 
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-600 focus:outline-none"
              >
                <span className="sr-only">Close panel</span>
                <NXCross aria-hidden="true" className="h-3 w-3" />
              </button>
            )}
          </div>
          
          {/* Drawer Content */}
          <div className="flex-1 overflow-y-auto p-4">
            {children || (
              <div>
                {/* Example of Dummy Fields */}
                <label className="block text-sm font-medium text-gray-700">
                  Dummy Field 1
                </label>
                <InputField
                  type="text"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />

                <label className="block text-sm font-medium text-gray-700 mt-4">
                  Dummy Field 2
                </label>
                <InputField
                  type="text"
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default NxtbnDrawer;
